import type { FeedType } from '../../state/types';

import type { FeedIdentifier } from './types';
type GetFeedId = (options: FeedIdentifier) => string;
const defaultFeedSubtypeMap: Record<FeedType, FeedIdentifier['subtype']> = {
  AttachableLink: undefined,
  Bookmark: undefined,
  Group: 'ALL',
  Campaign: 'ALL',
  GroupAgentSuggestions: 'PENDING',
  GroupTopQuestions: undefined,
  GroupSimilarQuestions: undefined,
  Home: 'DISCOVERY',
  MoreForYou: undefined,
  Inbox: 'ALL',
  InboxDraft: undefined,
  InboxScheduled: undefined,
  LeaderEmployees: undefined,
  LeaderHighlighted: undefined,
  LiveEvent: 'ALL',
  MyLeaders: 'ALL',
  DiscoveryNetworkQuestion: undefined,
  NetworkQuestion: 'ALL',
  NetworkQuestionInbox: 'ALL',
  NetworkTheme: undefined,
  Promoted: undefined,
  Search: undefined,
  SingleNetworkQuestion: undefined,
  StorylineAll: undefined,
  StorylineDiscovery: undefined,
  StorylineFollowed: undefined,
  TeamsMeeting: 'ALL',
  Thread: undefined,
  Topic: undefined,
  TopicNetworkQuestion: undefined,
  TopicUnified: 'ALL',
  User: undefined,
  UserWall: undefined,
  UserGroups: undefined,
  M365CopilotSuggestion: undefined,
};
type GetDefaultSubtype = (type: FeedType) => FeedIdentifier['subtype'];
export const getDefaultSubtype: GetDefaultSubtype = (type) => defaultFeedSubtypeMap[type];
export const getId: GetFeedId = ({ type, entityId, subtype }) => {
  if (type === 'AttachableLink') {
    return attachableLinkFeedId;
  }
  const defaultedSubtype = subtype || getDefaultSubtype(type);
  // We don't want consumers manually constructing feed IDs, so we base64-encode them.
  const id = [type, entityId, defaultedSubtype].join('/');

  return `${id}-${btoa(id)}`;
};
export const networkQuestionInboxUnreadFeedId: string = getId({
  type: 'NetworkQuestionInbox',
  subtype: 'UNREAD',
});
export const networkQuestionInboxAllFeedId: string = getId({
  type: 'NetworkQuestionInbox',
  subtype: 'ALL',
});
export const networkQuestionInboxThreadStarterSenderFeedId: string = getId({
  type: 'NetworkQuestionInbox',
  subtype: 'VIEWER_IS_THREAD_STARTER_SENDER',
});
export const inboxUnreadFeedId: string = getId({ type: 'Inbox', subtype: 'UNREAD' });
export const inboxDirectFeedId: string = getId({ type: 'Inbox', subtype: 'DIRECT' });
export const inboxAllFeedId: string = getId({ type: 'Inbox', subtype: 'ALL' });
export const myLeadersUnseenFeedId: string = getId({ type: 'MyLeaders', subtype: 'UNSEEN' });
export const attachableLinkFeedId = 'attachableLinkFeedId';
